import {
  arrayBuilderYesNoSchema,
  arrayBuilderYesNoUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import DischargePapersDescription from '../../../../components/FormDescriptions/DischargePapersDescription';
import { DISCHARGE_DOC_TYPES } from '../../../../utils/constants';
import content from '../../../../locales/en/content.json';

const yesNoOptions = {
  title: content['service-info--attachments-yes-no-title'],
  hint: null,
  labelHeaderLevel: '',
};

const yesNoOptionsMore = {
  title: content['service-info--attachments-yes-no-more-title'],
  hint: null,
  labelHeaderLevel: '',
};

const valueOrEmDash = value => value || '—';

/** @type {ArrayBuilderOptions} */
export const attachmentsOptions = {
  arrayPath: 'attachments',
  nounSingular: 'document',
  nounPlural: 'documents',
  required: false,
  text: {
    summaryTitle: content['service-info--attachments-review-title'],
    summaryTitleWithoutItems: content['service-info--attachments-title'],
    summaryDescriptionWithoutItems: DischargePapersDescription,
    getItemName: item => valueOrEmDash(item?.attachmentFile?.name),
    cardDescription: item =>
      valueOrEmDash(DISCHARGE_DOC_TYPES[item?.attachmentId]),
  },
};

export default {
  uiSchema: {
    'view:hasAttachments': arrayBuilderYesNoUI(
      attachmentsOptions,
      yesNoOptions,
      yesNoOptionsMore,
    ),
  },
  schema: {
    type: 'object',
    properties: {
      'view:hasAttachments': arrayBuilderYesNoSchema,
    },
  },
};
